<ll-toolnavbar>
    <banner-toolnavbar></banner-toolnavbar>
</ll-toolnavbar>

<ll-titulo>Banner Pagina #{{ bannerPaginaId || "" }}</ll-titulo>

<bannerPagina [bannerPaginaId]="bannerPaginaId"></bannerPagina>
